export default __webpack_public_path__ + "static/media/Complete_Icon.1f5cb91f.svg";